// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TuFSk","headingWrapper":"styles_headingWrapper__TCK5h","text":"styles_text__LHzD+"};